import React from 'react';
import { DnaIcon, HeartPulseIcon } from 'lucide-react';
import { SnakButton } from './SnakButton';
import { MoaVisual } from './MoaVisual';
type ExplainSceneProps = {
  inhibited: boolean;
  onToggle: () => void;
  onNext: () => void;
  still?: boolean;
};
export function ExplainScene({
  inhibited,
  onToggle,
  onNext,
  still = false
}: ExplainSceneProps) {
  return <div className="flex h-full flex-col" data-id="element-497" data-mp="sqm2ex30p5ym">
      <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-cap-gold" data-id="element-498" data-mp="dzmuzpdx4ngm">Mechanism of action</p>
      <h2 className="mt-1.5 text-[29px] font-extrabold leading-[1.04] tracking-[-0.03em] text-cap-purple" data-id="element-499" data-mp="irn1y1seogmp">A multikinase approach.</h2>
      <p className="mt-2 text-[13.5px] leading-snug text-cap-grey" data-id="element-500" data-mp="511es0vx5kj0">Vandetanib is an oral inhibitor of RET, VEGFR and EGFR tyrosine kinases.</p>

      <div className="relative -mx-2 mt-3 h-[236px]" data-id="element-501" data-mp="3r5wsfyba42os">
        <MoaVisual inhibited={inhibited} still={still} data-id="element-502" data-mp="3r8hw8sv50sp6" />
      </div>

      <button type="button" onClick={onToggle} aria-pressed={inhibited} className={`mt-2 h-11 w-full rounded-full text-[12px] font-bold tracking-[0.1em] transition-[background-color,color,transform] duration-150 active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cap-purple ${inhibited ? 'bg-cap-lilac text-cap-purple' : 'bg-cap-gold text-white hover:bg-cap-orange'}`} data-id="element-503" data-mp="3w46mu6p6iz9c">
        {inhibited ? '✓ KINASES INHIBITED · TAP TO RESET' : 'ADD VANDETANIB'}
      </button>

      <ul className="mt-3 space-y-2" data-id="element-504" data-mp="30gplugd3ojya">
        <li className="flex gap-2.5 rounded-xl bg-cap-lilac p-2.5" data-id="element-505" data-mp="30djvyywnde1i">
          <DnaIcon size={16} className="mt-0.5 flex-shrink-0 text-cap-purple" aria-hidden="true" data-id="element-506" data-mp="3e7uq5vrey0ey" />
          <p className="text-[11.5px] leading-snug text-cap-ink" data-id="element-507" data-mp="39fje5ujeeo61">
            <span className="font-bold" data-id="element-508" data-mp="2lq8ksy4dnw1x">RET status</span> informs patient selection — see current SmPC indication.
          </p>
        </li>
        <li className="flex gap-2.5 rounded-xl bg-cap-lilac p-2.5" data-id="element-509" data-mp="2honclq2sg5y2">
          <HeartPulseIcon size={16} className="mt-0.5 flex-shrink-0 text-cap-orange" aria-hidden="true" data-id="element-510" data-mp="kpapwx7cmzvb" />
          <p className="text-[11.5px] leading-snug text-cap-ink" data-id="element-511" data-mp="pmu2lsoef4l5">
            <span className="font-bold" data-id="element-512" data-mp="uec36fmif35l">QTc prolongation:</span> ECG and electrolytes before and during treatment.
          </p>
        </li>
      </ul>

      <div className="mt-auto pt-4" data-id="element-513" data-mp="zc3xfgamn1cy">
        <SnakButton onClick={onNext} data-id="element-514" data-mp="zf9jsnrvfp4z">CONTINUE</SnakButton>
      </div>
    </div>;
}